module.exports = __webpack_public_path__ + "static/img/battery_s.dd10f90b.svg";